import React from "react";

import clsx from "clsx";
import copy from "copy-to-clipboard";
import { AnimatePresence, motion } from "framer-motion";
import { useToasts } from "react-toast-notifications";

import { StuckToTop } from "@components/stuck-to-top";
import { useUser } from "@components/user-context";
import { SecondaryButton } from "@components/v2";
import { prettyLogEvent } from "@internal/analytics";
import { Pages } from "@north-beam/nb-client-side/constants";

import { useCollapseTopBar } from "../atoms";

import { ReportBodyControl } from "./report-body-control";
import { SavedViewsControl } from "./saved-views-control";

export const CreativeAnalyticsControl = () => {
  const toast = useToasts();
  const [isExpanded] = useCollapseTopBar();
  const { user } = useUser();

  if (user.featureFlags.enableDashboardV2) {
    return (
      <div className="flex flex-row items-end w-full">
        <ReportBodyControl isLoading={false} />
        <SavedViewsControl />
      </div>
    );
  }
  return (
    <StuckToTop className="border-b-0">
      {() => (
        <AnimatePresence initial={true}>
          {isExpanded && (
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: "auto" }}
              exit={{ height: 0 }}
              transition={{ ease: "easeOut", duration: 0.2 }}
              className="flex flex-row h-[5rem] mr-0 items-end"
            >
              <SavedViewsControl />
              <ReportBodyControl isLoading={false} />
              <SecondaryButton
                className={clsx("ml-auto mr-5 flex flex-row items-center")}
                onClick={() => {
                  toast.addToast("LINK COPIED TO CLIPBOARD", {
                    appearance: "success",
                  });
                  copy(window.location.href);
                  prettyLogEvent.onClick({
                    user,
                    page: Pages.CREATIVE_ANALYTICS,
                    additionalActionInfo: "share",
                  });
                }}
              >
                <i className="mr-2 text-lg fa-regular fa-sharp fa-link" />
                <div>SHARE</div>
              </SecondaryButton>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </StuckToTop>
  );
};
